const o = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
    <path
        d="M8.25,0H1.75A1.752,1.752,0,0,0,0,1.75v6.5A1.752,1.752,0,0,0,1.75,10h6.5A1.752,1.752,0,0,0,10,8.25V1.75A1.752,1.752,0,0,0,8.25,0ZM8.5,8.25a.25.25,0,0,1-.25.25H6.375l1-.75a.625.625,0,0,0-.75-1l-1,.75V5.908A1.867,1.867,0,0,0,7,4.155V2.808a.333.333,0,0,0-.482-.275L5,3.233l-1.518-.7A.333.333,0,0,0,3,2.808V4.155A1.867,1.867,0,0,0,4.375,5.908V7.5l-1-.75a.625.625,0,1,0-.75,1l1,.75H1.75a.25.25,0,0,1-.25-.25V1.75a.25.25,0,0,1,.25-.25h6.5a.25.25,0,0,1,.25.25Z"
        fill="currentColor" stroke="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="0"></path>
</svg>`;
export {
  o as default
};
